import '@babel/polyfill'
import 'intersection-observer'
import React from 'react'
import { render } from 'react-dom'
import Centrum from '../layouts/centrum'
import RavenWrapper from '../components/utils/Raven'

const {
  sentry,
  version,
  environment
} = __INITIAL_STATE__.config
const container = document.getElementById('homepage')

render(
  <RavenWrapper config={sentry} version={version} environment={environment}>
    <Centrum widgets={__INITIAL_STATE__} layout='centrum' clientSide/>
  </RavenWrapper>,
  container
)
